import 'leaflet-contextmenu'
import L from 'leaflet'

import url from '@/utils/url'
import BorderDrawer from '@/utils/map/BorderDrawer'
import { TILE_LAYER } from '@/config/map'
import { msn } from '@/api/api-endpoints'
import FkkoMixin from '@/mixins/fkko-mixin'
import RegopMixin from '@/mixins/regop-mixin'
import RouteMixin from '@/mixins/route-mixin'
import year from '@/utils/year'
import hasMixin from '@/mixins/has-mixin'

export default {
  data() {
    this.map = null
    this.initialAddresses = null
    this.apoIds = null
    return {
      q: '',
    }
  },
  mixins: [FkkoMixin, RouteMixin, RegopMixin, hasMixin],
  computed: {
    mapBorders() {
      return []
    },
    mapBringTo() {
      return this.$store.getters.mapBringTo
    },
    updateMapStatus() {
      return this.$store.getters.updateMapStatus
    },
    contextmenu() {
      return true
    },
    contextmenuOpened() {
      return true
    },
  },
  mounted() {
    this.initMap()
    this.drawTiles()
    this.drawBorders()
  },
  methods: {
    getMapPolygon() {
      return []
    },
    getPreferCanvas() {
      return true
    },
    async initMap() {
      this.map = L.map(this.$refs.map, {
        center: this.getMapConfig('center'),
        zoom: this.getMapConfig('zoom'),
        minZoom: this.getMapConfig('minZoom'),
        // needed for marker cluster group
        maxZoom: 18,
        contextmenu: true,
        preferCanvas: this.getPreferCanvas(),
        contextmenuWidth: 220,
        contextmenuOpened: this.contextmenuOpened,
        contextmenuItems: [
          {
            text: 'Что это?',
            callback: (e) => this.$emitter.emit('whatisit', e),
          },
        ],
      })

      this.map.on('zoom', this.zoomHandler)
      this.map.on('moveend', this.moveendHandler)

      L.DomUtil.addClass(this.map._controlContainer, 'no-print')
      const afterMapInit = await this.afterMapInit()
      if (afterMapInit) {
        this.$emitter.emit('mapInit')
      }
    },
    drawTiles() {
      L.tileLayer(TILE_LAYER).addTo(this.map)
    },
    drawBorders() {
      this.borderDrawer = new BorderDrawer(this.map, this)
      this.borderDrawer.drawAll(this.getMapPolygon(), this.mapBorders)
      this.borderDrawer.drawLocality(this.mapBorders, true)
    },
    setView(data) {
      if (this.map) {
        setTimeout(() => {
          this.map.setView([data.lat, data.lng], data.zoom)
        }, data.delay || 0)
        if (data.refreshMap) {
          this.refreshMap()
        }
      }
    },
    updateMap() {},
    setFiltersFromUrl() {
      let route = url.getRoute(this.$route)

      if (route.query.q) {
        this.q = route.query.q
      } else {
        this.q = ''
      }
    },
    routeHandler() {
      this.setFiltersFromUrl()

      this.refreshMap()
    },
    async updateRouteStateFromMap() {
      if (this.map) {
        let latlng = this.map.getCenter()
        await this.replaceRoute({
          zoom: this.map.getZoom(),
          center: [latlng.lat, latlng.lng],
        })
      }
    },
    async moveendHandler() {
      if (this.map) {
        let latlng = this.map.getCenter()
        await this.replaceRoute({ center: [latlng.lat, latlng.lng] })
      }
    },
    async zoomHandler() {
      if (this.map) {
        await this.replaceRoute({ zoom: this.map.getZoom() })
      }
      if (this.threadsDrawer) {
        this.threadsDrawer.redrawAll()
      }
    },
    getMapConfigData() {
      console.error('define getMapConfigData method')
    },
    getMapConfig(name) {
      let usedRoute = url.getPrevOrCurrentRoute(this.$route)

      if (usedRoute.query[name]) {
        // return copy of object, without listeners
        let route = usedRoute
        if (
          typeof route.query[name] === 'string' &&
          route.query[name].indexOf(',') > -1
        ) {
          return route.query[name].split(',')
        }
        return route.query[name]
      }
      return this.getMapConfigData()[name]
    },
    /* required for use in map-poup */
    registerClosePopup() {
      this.replaceRoute({ openedPopupInfo: null, lastEventPos: null })
    },
    /* required for use in map-popup */
    registerOpenPopup(marker) {
      if (marker.options.openedPopupInfo) {
        // lastEventPos - need for register correct relation popup pos
        this.replaceRoute({
          openedPopupInfo: marker.options.openedPopupInfo,
          lastEventPos: marker.options.lastEventPos,
        })
      }
    },
    destroyMap() {
      if (this.map !== null) {
        this.map.remove()
        this.map = null
      }
    },
    destroyAsync() {
      console.info('please define destroyAsync')
    },
    getQuery() {
      const query = {}
      if (this.fkkoList.length) {
        query.fkko_ids = this.fkkoList.map((item) => item.id).join(',')
      } else {
        delete query.fkko_ids
      }
      if (this.dangerClasses.length) {
        query.danger_classes = this.dangerClasses.join(',')
      } else {
        delete query.danger_classes
      }
      if (this.containers.length) {
        if (this.hasRouteMsnSearchType) {
          query.container_type_id = this.containers.join(',')
        } else {
          query.container_id = this.containers.join(',')
        }
      } else {
        delete query.container_id
        delete query.container_type_id
      }
      let currentYear = year.getCurrentYear()
      if (this.$route.query.year) {
        currentYear = this.$route.query.year
      }
      query.year = currentYear

      return query
    },
    async getMsnRequest() {
      const query = this.getQuery()
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: msn.addressesWithRoute({ query }),
        fromCache: false,
      })

      this.initialAddresses = [...this.msns]
      this.$store.commit('mutateEndpoint', {
        endpoint: msn.addresses(this.$route),
        response,
      })

      this.redrawPoints()
    },
    getInitialAddresses() {
      this.$store.commit('mutateEndpoint', {
        endpoint: msn.addresses(this.$route),
        response: { data: this.initialAddresses },
      })
      this.dangerClasses = []
    },
  },
  destroyed() {
    this.destroyMap()
  },
}
